/// <amd-module name="Checks/ChecksOverview/ChecksSource" />

import * as Resources from "Checks/ChecksOverview/Resources";
import * as PipelineChecksContracts from "Checks/Client/Contracts/PipelinesChecks";
import { IPipelinesChecksRestClient, PipelinesChecksClientName } from "Checks/Client/RestClient/PipelinesChecks";

import { ITfsPageService } from "Tfs/Platform/Page";
import { IVssPageContext } from "VSS/Platform/Context";
import { IVssContributionService } from "VSS/Platform/Contribution";

export class ChecksSource {

    public static getInstance(pageContext: IVssPageContext) {
        if (!this._instance) {
            ChecksSource._pageContext = pageContext;
            ChecksSource._instance = new ChecksSource();
            ChecksSource._policyAssignmentRestClient = ChecksSource._pageContext.getRestClient<IPipelinesChecksRestClient>(PipelinesChecksClientName);
        }

        return ChecksSource._instance;
    }

    public getData<T = { [key: string]: any }>(contributionId: string, dataProviderRequestParameters: { [key: string]: any }) {
        return this._service.getData<T>(contributionId, dataProviderRequestParameters);
    }

    public addCheck(check: PipelineChecksContracts.CheckConfiguration): Promise<PipelineChecksContracts.CheckConfiguration> {
        return ChecksSource._policyAssignmentRestClient.addCheckConfiguration(check, this._project);
    }

    public updateCheck(check: PipelineChecksContracts.CheckConfiguration) {
        return ChecksSource._policyAssignmentRestClient.updateCheckConfiguration(check, this._project, check.id);
    }

    public deleteCheck(checkAssignmentId: number): Promise<void> {
        return ChecksSource._policyAssignmentRestClient.deleteCheckConfiguration(this._project, checkAssignmentId);
    }

    public get _project(): string {
        let pageService = ChecksSource._pageContext.getService<ITfsPageService>("ITfsPageService");
        const pageData = pageService.getData();

        if (!pageData || !pageData.project) {
            throw new Error(Resources.PageContext_Error_ProjectDataUnavailable);
        }

        return pageData.project.id;
    }

    private get _service(): IVssContributionService {
        return ChecksSource._pageContext.getService<IVssContributionService>("IVssContributionService");
    }

    private static _instance: ChecksSource;
    private static _pageContext: IVssPageContext;
    private static _policyAssignmentRestClient: IPipelinesChecksRestClient;
}
